/** 日历窄格也需看清由哪家分包商施工；优先公司名，缺失时回退联系人/账号。
 * 仅缩短展示，不改存量名称；不生成易重名的首字母代码，完整名称保留在提示与朗读文本中。
 */
import React from "react";

export const contractorName = (task) => String(task.company || task.subcontractorName || task.subcontractorUserId || "").trim();
export const contractorShortName = (name) => {
  const full = String(name || "").trim().replace(/\s+/g, " ");
  const simple = full.replace(/(?:[\s,]+(?:incorporated|corporation|corp\.?|inc\.?|llc\.?|ltd\.?))+$/i, "").replace(/(?:有限责任公司|股份有限公司|有限公司)$/, "").trim() || full;
  const chars = Array.from(simple), max = /[\u3400-\u9fff]/.test(simple) ? 8 : 18;
  return chars.length > max ? `${chars.slice(0, max - 1).join("")}…` : simple;
};

/** Combo 市检可包含多家队伍：去重后显示前两家，额外人数及完整名单仍可辨认。 */
export default function ScheduleContractor({ task, items, zh }) {
  const names = [...new Set((items || [task]).filter(Boolean).map(contractorName).filter(Boolean))];
  if (!names.length) return null;
  const full = names.join(" · "), short = names.slice(0, 2).map(contractorShortName).join(" · ");
  return <span data-testid="schedule-contractor-name" title={full} aria-label={`${zh ? "分包商" : "Subcontractor"}: ${full}`} className="mt-1 block truncate text-[10px] font-semibold text-slate-800">
    {short}{names.length > 2 ? ` +${names.length - 2}` : ""}
  </span>;
}
